// extracted by mini-css-extract-plugin
module.exports = {"dp-input":"input_dp-input__2_unz"};